import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonRegularSearchIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M4.86 5.25a1.7 1.7 0 0 1 .513-1.215 1.75 1.75 0 0 1 1.238-.504 1.78 1.78 0 0 1 1.237.504 1.72 1.72 0 0 1 .513 1.215 1.7 1.7 0 0 1-.513 1.215 1.75 1.75 0 0 1-1.237.504 1.78 1.78 0 0 1-1.237-.504A1.72 1.72 0 0 1 4.86 5.25m4.55 0c0-.73-.294-1.429-.82-1.945A2.83 2.83 0 0 0 6.61 2.5c-.742 0-1.454.29-1.979.805a2.73 2.73 0 0 0-.82 1.945c0 .73.295 1.429.82 1.945A2.83 2.83 0 0 0 6.611 8c.743 0 1.455-.29 1.98-.805s.82-1.216.82-1.945m-6.65 7.563c0-1.52 1.254-2.75 2.8-2.75h1.755q.028-.543.206-1.032H5.56c-2.126 0-3.85 1.693-3.85 3.781v.172a.52.52 0 0 0 .525.516.52.52 0 0 0 .525-.516zm8.226-4.126c.418 0 .818.163 1.114.454a1.53 1.53 0 0 1 0 2.187 1.6 1.6 0 0 1-1.114.453 1.6 1.6 0 0 1-1.114-.453 1.53 1.53 0 0 1-.461-1.094c0-.41.166-.803.461-1.093a1.6 1.6 0 0 1 1.114-.453m0 4.126c.534 0 1.03-.157 1.446-.426l1.332 1.308a.53.53 0 0 0 .742 0 .51.51 0 0 0 0-.728l-1.333-1.308c.276-.408.436-.898.436-1.425 0-1.424-1.175-2.578-2.625-2.578S8.359 8.81 8.359 10.234c0 1.425 1.174 2.579 2.625 2.579z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M1 2.5h14v11H1z"
		})
	}) })]
});
export default SvgPersonRegularSearchIcon;
